import { render, staticRenderFns } from "./ConnectWalletChooseWallet.vue?vue&type=template&id=008e1f31"
import script from "./ConnectWalletChooseWallet.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletChooseWallet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports